// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2R1Aq","containerItemsCenter":"Skeleton_containerItemsCenter__101KR"};